import { FunctionComponent } from "react"
import Sidebar from "../../features/sidebar/components/sidebar"
import RecruiterWelcomePage from "./WelcomePage"

/**
 * Recruiter Dashboard Wrapper
 * Displays the welcome page for Recruiter users at /dashboard/recruiter
 * Analytics pages (composite, benchmark, performance) are handled by RecruiterDashboard directly
 */
const RecruiterDashboardWrapper: FunctionComponent = () => {
  return (
    <div className="relative bg-white w-full h-[100dvh] flex flex-row items-start justify-start">
      <Sidebar />
      <div className="w-full h-[100dvh] flex-1 flex flex-col overflow-hidden">
        {/* Content Area */}
        <div className="flex-1 overflow-auto bg-gray-50">
          <RecruiterWelcomePage />
        </div>
      </div>
    </div>
  )
}

export default RecruiterDashboardWrapper
